import React from "react";
import Box from "@mui/material/Box";
import CustomDateHistory from "./CustomDateHistory";

export default function History() {
  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <CustomDateHistory />
      </Box>
    </div>
  );
}
